var module = angular.module('octopusApp.master', []);



//////////////////
// WEBPACK FOOTER
// ./app/areas/master/master_module.js
// module id = 2591325598974518
// module chunks = 1